import { useContext } from 'react';

import SeasonalCard from '@/components/game/ui/card/SeasonalCard';
import { GameContext } from '@/state/contexts';
import { logg } from '@/util/logg';
import '@/style/HandModal.css';

const DiscardPileModal = ({ onClose }) => {
	const { discardPile }: any = useContext(GameContext);

	logg('discardPile');
	logg(discardPile);

	if (discardPile == null || discardPile.length === 0) {
		return;
	}

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<h2>{'Discard Pile'}</h2>
				<div className="hand">
					{discardPile.map((cardId: number) => (
						<div className="card">
							{' '}
							<SeasonalCard
								cardId={cardId}
								width={0}
								height={0}
							/>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default DiscardPileModal;
